import { useEffect, useState } from 'react';

import { cfetch } from '@confluence/network';

import { type SuggestionGroup } from '../types/RemoteObject.ts';

type SuggestionsResponse = {
	suggestions: SuggestionGroup[];
};

export type UseFetchSuggestionsResult = {
	groups: SuggestionGroup[];
	isLoading: boolean;
};

export const useFetchSuggestions = (spaceKey?: string): UseFetchSuggestionsResult => {
	const [groups, setGroups] = useState<SuggestionGroup[]>([]);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		if (!spaceKey) {
			setIsLoading(false);
			return;
		}

		setIsLoading(true);

		const fetchSuggestions = async () => {
			try {
				const response = await cfetch(
					`/wiki/rest/internal/1.0/spaces/${spaceKey}/remote-objects/suggestions`,
					{ method: 'GET' },
				);

				const data: SuggestionsResponse = await response.json();
				if (data.suggestions && data.suggestions.length > 0) {
					setGroups(data.suggestions);
				}
			} catch {
				// Silently fail — card won't render if there are no suggestions
			} finally {
				setIsLoading(false);
			}
		};

		void fetchSuggestions();
	}, [spaceKey]);

	return { groups, isLoading };
};
